module.exports = __webpack_public_path__ + "static/media/giovanni-max.193f9d22.wav";